import { render } from "./KaAdd.vue?vue&type=template&id=06628662&scoped=true"
import script from "./KaAdd.vue?vue&type=script&lang=js"
export * from "./KaAdd.vue?vue&type=script&lang=js"

import "./KaAdd.vue?vue&type=style&index=0&id=06628662&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06628662"]])

export default __exports__